// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__2m4Ip","grid__item":"styles_grid__item__3fp1J","grid__item__wrapper-forks":"styles_grid__item__wrapper-forks__K4J6G"};